/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Insufficientcredits_Descriptionfree2Inputs */

const zh_chat_insufficientcredits_descriptionfree2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的积分余额已用完，无法发送消息。请升级订阅以获取更多积分。`)
};

const en_chat_insufficientcredits_descriptionfree2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've run out of credits and cannot send messages. Please upgrade your subscription to get more credits.`)
};

const es_chat_insufficientcredits_descriptionfree2 = /** @type {(inputs: Chat_Insufficientcredits_Descriptionfree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te has quedado sin créditos y no puedes enviar mensajes. Actualiza tu suscripción para obtener más créditos.`)
};

/**
* | output |
* | --- |
* | "You've run out of credits and cannot send messages. Please upgrade your subscription to get more credits." |
*
* @param {Chat_Insufficientcredits_Descriptionfree2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_insufficientcredits_descriptionfree2 = /** @type {((inputs?: Chat_Insufficientcredits_Descriptionfree2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Insufficientcredits_Descriptionfree2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_insufficientcredits_descriptionfree2(inputs)
	if (locale === "en") return en_chat_insufficientcredits_descriptionfree2(inputs)
	return es_chat_insufficientcredits_descriptionfree2(inputs)
});
export { chat_insufficientcredits_descriptionfree2 as "chat_insufficientCredits_descriptionFree" }